module.exports = function() {
  return new Worker(__webpack_public_path__ + "7f1c8e7de464eca8145d.worker.js");
};